
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  toRef,
  watch,
} from "vue";
import { IBulkDelete } from "@/interfaces/iPageModel";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { INNER_PAGE_ROWS_PER_PAGE, usePagination } from "@/helpers/pagination";
import { FormatMethods } from "@/helpers/data-format";
import { FormApi } from "@/services/api/Form.service";
import { UserAPI } from "@/services/api/User.service";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import {
  formUserTableBulkDelete,
  // formUserTableFilters,
  formUserTableHeaders,
} from "../dataTableOptions";
import { IUser } from "@/interfaces/iUser";
import { IForm, IFormUser } from "@/interfaces/iForm";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";
import { getLookups } from "@/services/api/Lookup.service";
import * as Yup from "yup";
import { useToast } from "vue-toastification";
import PreviewLink from "@/components/typography/PreviewLink.vue";
import UserDetailModal from "@/views/user/modal/UserDetailModal.vue";
import RoleDetailModal from "@/views/user/modal/RoleDetailModal.vue";
import { hasPermission } from "@/core/services/permission.service";
import { IRole } from "@/interfaces/iRole";
import { debounce } from "lodash";
export default defineComponent({
  name: "FormUser",
  props: {
    data: { type: Object as PropType<IForm>, required: true },
    openDrawer: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
  },
  components: {
    Datatable,
    VZDeleteModal,
    PreviewLink,
    UserDetailModal,
    RoleDetailModal,
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const dataProp = toRef(props, "data");
    const openDrawer = toRef(props, "openDrawer");
    const { page, total } = usePagination();
    const rowsPerPage = ref(INNER_PAGE_ROWS_PER_PAGE);
    const showDeleteDialog = ref<any>(false);
    const loading = ref(false);
    const defaultFilter = ref({ status: "ACTIVE" });
    const showSearch = true;
    const tableData = ref<IFormUser[]>([]);
    const allTableData = ref<IFormUser[]>([]);
    const showDetailDialog = ref<any>(false);
    const showRoleDetailDialog = ref<any>(false);
    const selectedForAction = ref<Partial<IFormUser>>({});
    const selectedUser = ref<Partial<IUser>>({});
    const selectedRole = ref<Partial<IRole>>({});
    const localPreference = ref({});
    const bulkDelete = ref<IBulkDelete>(formUserTableBulkDelete());
    const tableHeader = ref(formUserTableHeaders());
    // const tableFilter = ref(formUserTableFilters());
    let selectionType = ref("");
    let options: { label: any; value: string; type: string }[] = [];
    let roles: { label: any; value: string }[] = [];
    let siteOptions: { label: any; value: string }[] = [];
    const userRoleAssignedMsg = t("pages.form.userRoleAssignedMsg");
    const loadingUserDetailModal = ref(false);
    const loadingRoleDetailModal = ref(false);
    const Datatable = ref();
    const format = computed(() => {
      return FormatMethods;
    });
    const updatedSitesValue = async (siteId) => {
      loadUsers(siteId);
    };
    let formData = ref<IAddEditFormModel>({
      header: "Forms",
      page: "Forms",
      edit: false,
      data: null,
      label: [{ addHeader: t("pages.form.assignUserAndRole") }],
      validationSchema: Yup.object({
        site: Yup.string().required(
          t("pages.form.sites") + " " + t("common.isRequired")
        ),
        value: Yup.array()
          .min(1, t("pages.form.usersRoles") + " " + t("common.isRequired"))
          .nullable()
          .required(t("pages.form.usersRoles") + " " + t("common.isRequired")),
      }),
      model: [
        {
          name: "site",
          label: t("pages.form.sites"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select branch",
          options: siteOptions,
          multiSelect: false,
          dependentFields: ["value"],
          onValueChange: updatedSitesValue,
        },
        {
          name: "value",
          label: t("pages.form.usersRoles"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select user/role",
          options: options,
          multiSelect: true,
        },
      ],
    });
    let permissionModel = ref<any>({
      create: "VYZOR:TEMPLATES:FORMS:CREATE",
      delete: "VYZOR:TEMPLATES:FORMS:DELETE",
      update: "VYZOR:TEMPLATES:FORMS:UPDATE",
    });
    onMounted(async () => {
      // await refreshList();
      loading.value = true;
      await getLookups(
        `site/siteForms/${dataProp.value.webId}/sites?page=0&size=1000`
      )
        .then((res: any) => {
          res.content.map((data: any) => {
            siteOptions.push({
              label: data.name,
              value: data.webId,
            });
          });
          // loadUsers(siteOptions[0].value);
        })
        .catch((err) => {
          return [];
        });
    });

    const loadSites = async () => {
      siteOptions = [];
      await getLookups(
        `site/siteForms/${dataProp.value.webId}/sites?page=0&size=1000`
      )
        .then((res: any) => {
          res.content.map((data: any) => {
            siteOptions.push({
              label: data.name,
              value: data.webId,
            });
          });
          formData.value.model[0].options = siteOptions;
        })
        .catch((err) => {
          return [];
        });
    };

    const loadUsers = async (siteId) => {
      options = [] as any;
      loading.value = true;
      await getLookups(`site/userSites/userAndRole?paramSiteIds=${siteId}`)
        .then((res) => {
          res.map((data) => {
            options.push({
              label: data.userRoleName,
              value: data.userRoleId,
              type: data.type,
            });
          });
          const idsArray = options.map((item) => Number(item.value));
          const idsToRemove = idsArray.filter((value) => {
            // Check if the value exists in either roleId or userId of any object in the second array
            return allTableData.value.some((obj) => {
              if (obj.roleId === -1) {
                return obj.userId == value && obj.siteId == siteId;
              } else {
                return obj.roleId == value && obj.siteId == siteId;
              }
            });
          });
          const filteredOptions = options.filter(
            (item) => !idsToRemove.some((id) => id === parseInt(item.value))
          );
          formData.value.model[1].options = filteredOptions;
        })
        .catch((err) => {
          return [];
        })
        .finally(() => {
          loading.value = false;
        });
    };
    const onModalShow = () => {
      loadSites();
      formData.value.model[1].options = [];
    };

    const syncQuery = async (params?: Record<string, number | string>) => {
      queryUpdate(dataProp.value.webId, params);
    };

    const queryUpdate = async (
      webId: number,
      params?: Record<string, number | string>
    ) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
          };
        }
        const data = await FormApi.getInstance().getFormUser({
          ...params,
          formDefinitionId: dataProp.value.webId,
        });
        const allData = await FormApi.getInstance().getFormUser({
          status: "ACTIVE",
          size: 10000,
          formDefinitionId: dataProp.value.webId,
        });
        localPreference.value = { ...params };
        allTableData.value = [...allData.content];
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        loading.value = false;
      }
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate(dataProp.value.webId, { ...localPreference.value });
    };

    const openDetailModal = async (form) => {
      showDetailDialog.value = true;
      try {
        loadingUserDetailModal.value = true;
        selectedUser.value = {};
        const data = await UserAPI.getInstance().getUserById(form.userId);
        selectedUser.value = data;
      } finally {
        loadingUserDetailModal.value = false;
      }
    };

    const openRoleDetailModal = async (form) => {
      showRoleDetailDialog.value = true;
      try {
        loadingRoleDetailModal.value = true;
        selectedRole.value = {};
        const data = await UserAPI.getInstance().getRoleById(form.roleId);
        selectedRole.value = data;
      } finally {
        loadingRoleDetailModal.value = false;
      }
    };

    const submit = async (reqData) => {
      let reqDataArray: {
        roleId?: number;
        userId?: number;
        formDefinitionId: number;
        siteId: number;
      }[] = [];

      reqData.value.forEach((value: any) => {
        let reqDataItem: {
          roleId?: number;
          userId?: number;
          formDefinitionId: number;
          siteId: number;
        } = {
          formDefinitionId: dataProp.value.webId,
          siteId: reqData.site,
        };
        const isRoleSelected = options.some(
          (val) => val.value == value && val.type == "ROLE"
        );

        if (isRoleSelected) {
          reqDataItem.roleId = value;
        } else {
          reqDataItem.userId = value;
        }

        reqDataArray.push(reqDataItem);
      });

      await FormApi.getInstance()
        .addFormUsers(reqDataArray)
        .then(() => {
          toast.success(userRoleAssignedMsg);
          refreshList();
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const webId = computed(() => props.data?.webId);
    let lastFetchedWebId = null;
    const debouncedQueryUpdate = debounce(async (webId) => {
      if (webId !== lastFetchedWebId) {
        tableData.value = [];
        allTableData.value = [];
        lastFetchedWebId = webId;
        defaultFilter.value = { ...defaultFilter.value };
        rowsPerPage.value = INNER_PAGE_ROWS_PER_PAGE;
        queryUpdate(+webId, {
          ...defaultFilter.value,
          page: page.value - 1,
          size: rowsPerPage.value,
        });
        if (Datatable.value.VZFilter) {
          Datatable.value.VZFilter.getSavedFilterList();
        }
        formData.value.model[1].options = [];
        options = [];
        siteOptions = [];
        loadSites();
      }
    }, 300);

    watch(
      () => props.isActive,
      async (isActive) => {
        if (isActive && dataProp.value.webId) {
          // await queryUpdate(dataProp.value.webId, {
          //   ...defaultFilter.value,
          //   page: page.value - 1,
          //   size: rowsPerPage.value,
          // });
          loading.value = true;
          if (Datatable.value?.VZFilter) {
            await Datatable.value.VZFilter.getAppliedFilters();
          }
          formData.value.model[1].options = [];
          options = [];
          siteOptions = [];
          loadSites();
        } else {
          tableData.value = [];
          allTableData.value = [];
        }
      }
    );
    return {
      bulkDelete,
      format,
      tableData,
      tableHeader,
      showSearch,
      page,
      total,
      rowsPerPage,
      defaultFilter,
      loading,
      selectedForAction,
      formData,
      syncQuery,
      refreshList,
      submit,
      openDetailModal,
      selectedUser,
      selectedRole,
      onModalShow,
      hasPermission,
      permissionModel,
      t,
      loadingUserDetailModal,
      loadingRoleDetailModal,
      openRoleDetailModal,
      showDeleteDialog,
      showDetailDialog,
      showRoleDetailDialog,
      Datatable,
    };
  },
});
